module.exports = __webpack_public_path__ + "img/no-goods-img.0d181440.png";